__turbopack_context__.v({
  "featuredIcon": "vSbl9q_featuredIcon",
  "organizationContentWrapper": "vSbl9q_organizationContentWrapper",
  "organizationLogoWrapper": "vSbl9q_organizationLogoWrapper",
  "organizationLogoWrapperHasBanner": "vSbl9q_organizationLogoWrapperHasBanner",
  "organizationTeaserTitle": "vSbl9q_organizationTeaserTitle",
  "organizationTeaserWrapper": "vSbl9q_organizationTeaserWrapper",
  "organizationTeaserWrapperPremium": "vSbl9q_organizationTeaserWrapperPremium",
});
